import React from 'react'

// Types
import { NavigationProps } from '../types'

// Hooks 
import { useContext } from 'react'

// Context
import { NavigationContext } from '../context'

const Navigator: React.FC<NavigationProps> = (props) => {
  
  const navigation = useContext(NavigationContext)
  const { history, index } = navigation

  const route: string = history[index]
  const params = new URLSearchParams(document.location.search)

  const Element: React.ElementType = navigation.routes[route]
  return <Element params={params} />

}

export default Navigator